import { useMemo, useState } from 'react'
import {
  getCargasPendentesParaPicking,
  getDeliveriesByCicloForPicking,
} from '../../../../services/api/https/picking/picking.http'
import { errorHandler } from '../../../../services/util/error.service'

const INITIAL_STATE = {
  cargas: [],
  errorMessage: null,
  isLoading: false,
  modal: {
    show: false,
    deliveries: [],
    isLoading: false,
    cargaInfo: null,
  },
}
export default function useCargasPendentesParaPicking() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      resetMessage() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },
      async fetchEntregas(selectedTp) {
        try {
          if (selectedTp === 0) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Selecione o Operador Logístico desejado',
              isLoading: false,
            }))
          } else {
            setState(prevState => ({ ...prevState, isLoading: true }))
            const cargas = await getCargasPendentesParaPicking(selectedTp)
            setState(prevState => ({ ...prevState, isLoading: false, cargas }))
          }
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            isLoading: false,
          }))
        }
      },
      async onRowClick(carga, selectedTp) {
        try {
          setState(prevState => ({
            ...prevState,
            modal: {
              show: true,
              deliveries: [],
              isLoading: true,
              cargaInfo: carga,
            },
          }))

          const deliveries = await getDeliveriesByCicloForPicking(
            selectedTp,
            carga.ciclo_entrega.split(' - ')[0],
            carga.step,
          )

          setState(prevState => ({
            ...prevState,
            modal: {
              ...prevState.modal,
              deliveries,
              isLoading: false,
            },
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            modal: {
              ...prevState.modal,
              isLoading: false,
            },
          }))
        }
      },
      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: {
            show: false,
            deliveries: [],
            isLoading: false,
            cargaInfo: null,
          },
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
